import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimpleTable from 'components/shared/table/SimpleTable';
import { getReports } from 'selectors/admin/reports/reports';
import { Redirect } from 'react-router-dom';
import { usersUtil, ROLES, TYPES } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';

class Reports extends Component {
  state = {
    toReport: false,
    selectedReportRoute: '',
    userIsSpackleAdmin: usersUtil.hasRole(
      this.props.currentUser,
      ROLES.SPACKLE_ADMIN
    ),
    userIsSpackleBd: usersUtil.hasRole(
      this.props.currentUser,
      ROLES.BUSINESS_DEVELOPMENT
    ),
    userIsContractor: usersUtil.hasType(
      this.props.currentUser,
      TYPES.CONTRACTOR
    ),
    userIsGc: usersUtil.hasType(
      this.props.currentUser,
      TYPES.GENERAL_CONTRACTOR
    ),
  };

  handleRowSelection = (index) => {
    const route = `${this.props.match.url}/${this.props.reports[index].route}`;
    this.setState(() => ({
      toReport: true,
      selectedReportRoute: route,
    }));
  };

  handleGenerateLink = (index) => {
    const {
      match: { url },
      reports,
    } = this.props;
    return `${url}/${reports[index].route}`;
  };

  render() {
    if (this.state.toReport === true) {
      return <Redirect push to={this.state.selectedReportRoute} />;
    }

    return (
      <div className="reports">
        <div className="full-title">Reports</div>

        <div className="content-container">
          <SimpleTable
            className="quotes-table"
            headers={['NAME', 'DESCRIPTION']}
            rows={this.mapReports(this.props.reports)}
            emptyMessage="No Reports"
            onRowSelected={this.handleRowSelection}
            onGenerateLink={this.handleGenerateLink}
          />
        </div>
      </div>
    );
  }

  mapReports = (reports) => {
    return reports.map((report) => {
      if (this.props.match.url.includes('spe-reports')) {
        if (report.generalContractor) {
          return [report.name, report.description];
        } else {
          return [];
        }
      } else {
        if (
          (report.admin &&
            (this.state.userIsSpackleAdmin ||
              this.state.userIsSpackleBd ||
              this.state.userIsGc)) ||
          (report.contractor && this.state.userIsContractor)
        ) {
          return [report.name, report.description];
        } else {
          return [];
        }
      }
    });
  };
}

export default connect((state) => {
  return {
    reports: getReports(state),
    currentUser: getCurrentUser(state),
  };
})(Reports);



// WEBPACK FOOTER //
// ./src/components/admin/reports/Reports.js